import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { Body, Face } from '@phi/jcore';
import { faces_of_body } from '../../lattice';
import { State } from '../../state';
import { uil_get_body_of_face, uil_is_object_visible } from '../../ui_logic';
import { pipe } from '@vaaas/fpts/function';
import { map, every } from '@vaaas/fpts/iter';
import BarButton from '@components/bar-button';
import flip_normal_svg from '../../../assets/img/SVG_icons/Top/editing_model/flip_normal.svg';
import { img } from '@phi/components';
import { flip_body_faces_inside_out } from '@frontend/ui_display';
import FlipNormalTooltip from './FlipNormalTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const FlipNormalIcon = flip_normal_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Flip bodies inside out';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.rigid_move_manipulator
                || this.state.selected_faces_count === 0
                || !this.all_relevant_bodies_are_partially_visible();
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        all_relevant_bodies_are_partially_visible() {
            return pipe(
                uid_selected_faces.keys(),
                map(uil_get_body_of_face),
                every(this.is_partially_visible),
            );
        },

        is_partially_visible(x: Body) {
            return faces_of_body(x).some(this.is_object_invisble);
        },

        is_object_invisble(x: Face) {
            return !uil_is_object_visible(x);
        },

        onClick() {
            if (this.disabled)
                return;
            else
                flip_body_faces_inside_out();
        },
    },

    render() {
        return h(BarButton, {
            id: 'flip-normal-button',
            tippy: 'bottom',
            onClick: this.onClick,
            disabled: this.disabled,
            selected: this.state.tut_stage === 6,
            active: false,
            help: 'flip_normal',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(flip_normal_svg, this.alt),
            tooltip: FlipNormalTooltip,
        });
    },
});
